<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Sincronização</h4>

          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <!-- <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div> -->
        <div class="table-responsive table-full-width">
          <el-table
              :data="tableData()"
              v-loading="loading"
              style="width: 100%">
              <el-table-column type="expand">
              <template slot-scope="props">
                <p>
                  <span class="expandrow">Atualizado: </span>{{ props.row.updated }}
                  <p></p>
                  <span class="expandrow">Solicitação: </span>{{ props.row.dh_solicitacao }}
                  <p></p>
                  <span class="expandrow">Envio: </span>{{ props.row.dh_envio }}
                  <p></p>
                  <span class="expandrow">Confirmação: </span>{{ props.row.dh_confirmacao }}
                  <p></p>
                  <span class="expandrow" v-if="props.row.error">Erros: </span>{{ props.row.error }}
                </p>
                <template>
                  <json-view v-if="props.row.sent_data" :data="props.row.sent_data" :maxDepth="0" rootKey="Payload" />
                </template>
              </template>
              </el-table-column>
              <el-table-column
              label="VM"
              prop="vm.location">
              </el-table-column>
              <el-table-column
              label="Status"
              prop="status">
              </el-table-column>
              <el-table-column
              label="Tipo de atualização"
              prop="update_type">
              </el-table-column>
              <el-table-column
              label="Criado"
              prop="created">
              </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip, Loading } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      companyList: [],
      sync: [],
      search: '',
      loading: true,
      machineList: []
    };
  },
  computed: {
  },
  mounted() {
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).then(resp => {
        this.machineList = resp
        this.$store.dispatch("lockers/listSort",{sort: '?company=' + ciaID}).then(data =>{
          for (let index = 0; index < data.length; index++) {
            this.machineList.push(data[index])
          }
          this.$store.dispatch("sync/listSort",{sort: '?vm__company=' + ciaID}).then(()=>{
            this.tableData()
          }).catch(err => console.log(err));

        })
      })
    } else {
      this.$store.dispatch("machines/list").then(resp => {
        this.machineList = resp
        this.$store.dispatch("lockers/list").then(data =>{
          for (let index = 0; index < data.length; index++) {
            this.machineList.push(data[index])
          }
          this.$store.dispatch("sync/list").then(()=>{
            this.tableData()
          }).catch(err => console.log(err));
        })
      })
    }
    this.getListCompany()
    console.log('store', this.$store.state)
  },
  methods: {
    // getListCompany () {
    //   this.$store.dispatch('general/listUser').then(()=> {
    //     var x = this.$store.state.general.listUser.user_list_info
    //     this.companyList = x.filter((thing, index, self) =>
    //       index === self.findIndex((t) => (
    //         t.profile__company__id === thing.profile__company__id && t.profile__company__name === thing.profile__company__name
    //       ))
    //     )
    //   })
    // },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    tableData() {
      this.sync = this.$store.state.sync.syncs
      const machines =  this.machineList
      const populated = this.sync.map(v =>{
        let vm, updated, created, status, update_type
        if (v.vm) {
          vm = machines.find(e => e.id == v.vm);
        }
        if (v.status) {
          if (v.status === 'Q') {
            status = 'Na fila'
          }
          if (v.status === 'A') {
            status = 'VM confirmou recebimento'
          }
          if (v.status === 'C') {
            status = 'Cancelado'
          }
          if (v.status === 'S') {
            status = 'Enviado para VM'
          }
          if (v.status === 'R') {
            status = 'Tentando enviar novamente'
          }
          if (v.status === 'G') {
            status = 'VM realizou a solicitação'
          }
          if (v.status === 'E') {
            status = 'Erro'
          }
          if (v.status === 'X') {
            status = 'Expirado'
          }
        }
        if (v.update_type) {
          if (v.update_type === 'P') {
            update_type = 'Produto'
          }
          if (v.update_type === 'S') {
            update_type = 'Estoque'
          }
          if (v.update_type === 'C') {
            update_type = 'Configurações'
          }
          if (v.update_type === 'I') {
            update_type = 'Inventario'
          }
        }
        if (v.updated) {
          const d = new Date(v.updated);
          updated = d.toLocaleString("pt-BR");
        }
        if (v.created) {
          const h = new Date(v.created);
          created = h.toLocaleString("pt-BR");
        }
        return { ...v, vm, updated, created, status, update_type };
      })
      this.loading = false
      return populated
    },
    permission (permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
        if (el == permissao) {
          return true
        } 
      })
      if (x.length > 0) {
        return true
      }
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
span.expandrow {
  font-weight: bold;
}
</style>
